import { Box, Button, Grid, Modal, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import UserCard from "./userCard";
import { getAllCustomerDetails } from "./api";
import { searchedElementDisplay } from "./function";
import { Filter } from "../fiterComp";
const SearchModalCustomer = ({
  searchModal,
  countCredit,
  setSearchModal,
  callback,
  selectedValue,
  setDisplayErr,
  displayErr,
  setSelectedValue,
  feature,
  // userDetail,
}) => {
  const [getDataPayload, setGetDataPykoad] = useState({
    page: 1,
    pageSize: 1000,
    filter: "",
    search: "",
    filter2: "",
    search2: "",
  });
  const [collection, setCollection] = useState([]);
  const [searchCurrentModal, setSearchCurrentModal] = useState("");
  const getCounterSalesCusomter = async (param) => {
    // await getCounterSalesCustomers(param).then((res) => {
    //   console.log("countersales res data   ", res?.data?.data, " ", {
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   setPagination({
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   console.log("res?.data",res?.data?.data?.list)
    //   setUnPaidBill([...res?.data?.data?.list]);
    // });
  };

  useEffect(() => {
    console.log("dddd");
    if (searchModal === true) {
      getAllCustomerDetails(
        {
          ...getDataPayload,
          page: 1,
          pageSize: 1000,

          //  filter : "",
          //  search : "",
          //  filter2 : "",
          //  search2 : ""
        },
        (data) => {
          setCollection(data);
          console.log("data detail ", data);
        }
      );
      //   getCounterSalesCusomter({
      //     filter: "",

      //     search: "",
      //     page: 1,
      //     pageSize: 1000,
      //   });
      //   setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {
      console.log("close");
      //   setBillData(data);
      //   setUnPaidBillData();

      //   setSearchCurrentModal("")
    }
  }, [searchModal, getDataPayload]);
  const isUpcomingDate = (dateStr) => {
    if (!dateStr) return false;
    const today = new Date();
    const target = new Date(dateStr);

    target.setFullYear(today.getFullYear());

    if (target < today) {
      target.setFullYear(today.getFullYear() + 1);
    }

    const diff = (target - today) / (1000 * 60 * 60 * 24);
    return diff >= 0 && diff <= 30;
  };

  const applyClientSideFilter = (data, filterKey, searchValue) => {
    if (filterKey === "birthday") {
      return [...data]
        .filter((cust) => isUpcomingDate(cust.birthdate))
        .reverse();
    }

    if (filterKey === "Anniversarydate") {
      return [...data]
        .filter((cust) => isUpcomingDate(cust.anniversaryDate))
        .reverse();
    }

    if (filterKey === "customerGroup") {
      return data.filter((cust) => cust.customerGroup === searchValue);
    }

    return data;
  };
  const filteredCollection = applyClientSideFilter(
    collection,
    getDataPayload?.filter,
    getDataPayload?.search
  );
  return (
    <Modal
      open={searchModal}
      sx={{ zIndex: 999999 }} // Yo
      onClose={() => {
        setSearchModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid
        container
        sx={{
          borderRadius: "10px",
          background: "white",
          width: { xs: "95%", sm: "80%", md: "40%", lg: "35%", xl: "35%" },

          position: "absolute",
          left: { xs: "2%", sm: "15%", md: "30%", lg: "33%", xl: "33%" },

          top: "10%",
        }}
      >
        <Grid item xs={12} sx={{ padding: "20px" }}>
          <Box sx={{ textAlign: "center" }}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              label="Search Customer Name / Mobile No. :"
              value={searchCurrentModal}
              onChange={(e) => {
                // getPaymentRec(
                //   {
                //       "page": 1,
                //       "pageSize": 10,
                //       "filter": e.target.value,//"filter": null,
                //       "search": "",
                //       "date": null

                //   },
                //   getPaymentReceipt,
                //   setNumberOfRecords,
                //   setTotals,
                //   totals,
                //   setReceipts
                // );
                setSearchCurrentModal(e.target.value);
              }}
              InputLabelProps={{
                className: "mulish",
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
                endAdornment: (
                  <SearchIcon
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                ),
              }}
            />
            {/* <CloseIcon sx={{ float: "right", cursor: "pointer",marginRight:"12px", marginTop: "5px", color: (theme) => theme.palette.primary.main, }} onClick={() => setSearchModal(false)} /> */}
          </Box>
          <Filter
            setGetDataPykoad={setGetDataPykoad}
            getDataPayload={getDataPayload}
            groupFilter={true}
            categoryFilter={true}
            categorySize={4}
          />
          <Box sx={{ height: "55vh", overflowY: "auto" }}>
            {filteredCollection.map((item, index) => {
              if (searchedElementDisplay(item, searchCurrentModal)) {
                return null;
              }
              return (
                <UserCard
                  setDisplayErr={setDisplayErr}
                  feature={feature}
                  childEle={""}
                  countCredit={countCredit}
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  key={"employee" + index}
                  requiredLabel={false}
                  data={item}
                  callBack={() => {
                    callback(item);
                    // getUnpaid({
                    //   customerMobile: item?.mobile,
                    // });
                    // setBillData({
                    //   ...item,
                    //   customerMobile: item?.mobile,
                    //   customer: item?.name,
                    // // });
                    // setSearch(item?.name)
                    // setUSerObject(item)
                    // callSearchApi(item?.name)
                    // setSearchModal(false)
                  }}
                />
              );
            })}
          </Box>
          <Grid xs={12}>
            {displayErr?.status && (
              <Typography sx={{ color: "red" }}> {displayErr?.Msg} </Typography>
            )}
          </Grid>

          {feature == "bulkupload" && (
            <Grid xs={12} sx={{ padding: "10px 30px" }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  setSearchModal(false);
                }}
              >
                Done
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default SearchModalCustomer;
